// eslint-disable-file @typescript-eslint/no-explicit-any
import { ClientSideConfig } from 'types';

export const sendEvent = async (event: any, config: ClientSideConfig): Promise<any> => {
	const { brand, endpoints } = config;

	return fetch(`${endpoints.eventsApi}?eventType=${event['eventType']}`, {
		method: 'POST',
		credentials: 'omit',
		headers: {
			'Content-Type': 'application/json',
			'x-brand': brand.code,
		},
		body: JSON.stringify(event),
	})
		.then((response) => response.json())
		.catch((error) => console.error('Events API Error:', error));
};
